import React, { Fragment } from 'react'
import { Heading } from '@myxplor/ui'

export const NotAvailable = ({ children = 'This report is not avaible for use' }) => (
  <Fragment>
    <Heading small compact>Not available</Heading>
    {children}
  </Fragment>
)


// WEBPACK FOOTER //
// ./src/reports/reports/not-available.jsx